import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import { REGION_RU } from 'constants/regions'

import {
  Line,
  Content,
  Square,
  Wrapper,
  Inner,
  StepNumber,
  Title,
} from './styles'

const LIGHT = 'light'
const DARK = 'dark'
const TEXT_COLORS = [LIGHT, DARK]

const isRu = REGION_RU === process.env.region

/**
 * HowToBlock — Common block to wrap each step on an "how it works" page
 *
 * @param {object} props - properties of component
 * @returns {node} HowToBlock
 */
const HowToBlock = props => {
  const {
    index,
    title,
    titleContent,
    squareColor,
    textColor,
    lineColor,
    isFirst,
    isLast,
    children,
    isSquareHidden,
  } = props
  const { colors } = React.useContext(ThemeContext)
  const color = textColor === LIGHT ? colors.white : colors.black
  let lineClassName = lineColor === LIGHT ? 'light ' : 'dark '
  if (isFirst && !isLast) {
    lineClassName += 'first '
  }
  if (isLast && !isFirst) {
    lineClassName += 'last '
  }

  return (
    <Wrapper textColor={color}>
      <Line className={lineClassName} />
      <div className="position-relative">
        {!isSquareHidden && (
          <Square bgColor={squareColor}>
            <StepNumber as="div">{index}</StepNumber>
          </Square>
        )}
        <Content isRu={isRu}>
          <Inner>
            <Title dangerouslySetInnerHTML={{ __html: title }} />
            {titleContent}
          </Inner>
          {children}
        </Content>
      </div>
    </Wrapper>
  )
}

HowToBlock.propTypes = {
  /** Index of block */
  index: PropTypes.number.isRequired,

  /** Background color of square */
  squareColor: PropTypes.string.isRequired,

  /** Title of block */
  title: PropTypes.string.isRequired,

  /** Content for block */
  children: PropTypes.node,

  /** Flag to define is it first block */
  isFirst: PropTypes.bool,

  /** Flag to define is it last block */
  isLast: PropTypes.bool,

  /** Flag to control square visibility */
  isSquareHidden: PropTypes.bool,

  /** Color of vertical line */
  lineColor: PropTypes.oneOf(TEXT_COLORS),

  /** Color text */
  textColor: PropTypes.oneOf(TEXT_COLORS),

  /** Extra content for title */
  titleContent: PropTypes.node,
}

HowToBlock.defaultProps = {
  isSquareHidden: false,
  textColor: DARK,
  lineColor: DARK,
  isFirst: false,
  isLast: false,
  children: null,
  titleContent: null,
}

export default HowToBlock
